/*
 * Hero banner ALMAM.
 * Autonom fata de theme.Sections: se initializeaza singur si se reinitializeaza
 * la shopify:section:load, ca sa functioneze si in theme editor.
 */
(function () {
  var SELECTOR = '[data-hero-banner]';
  var instances = {};

  function destroy(id) {
    if (instances[id]) {
      instances[id].destroy(true, true);
      delete instances[id];
    }
  }

  function init(root) {
    if (!root) return;

    if (typeof window.Swiper === 'undefined') return;

    var id = root.dataset.sectionId;
    var slider = root.querySelector('.hero-banner__slider');
    var slides = root.querySelectorAll('.swiper-slide');

    if (!slider || slides.length < 2) return;

    destroy(id);

    /* Miscarea automata e o promisiune facuta vizitatorului, nu doar un efect:
       cine a cerut din sistem mai putina animatie nu trebuie sa primeasca un
       banner care se schimba singur. Fara autoplay si fara tranzitie. */
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var wantsAutoplay = root.dataset.sliderAutoplay === 'true' && !reduceMotion;
    var effect = root.dataset.sliderEffect === 'fade' ? 'fade' : 'slide';
    var speed = parseInt(root.dataset.sliderSpeed, 10) || 800;

    var swiper = new Swiper(slider, {
      /* Glisare laterala implicit; crossfade ramane optiune in editor pentru
         cand se vrea o schimbare mai discreta. */
      effect: effect,
      fadeEffect: { crossFade: true },
      loop: true,
      speed: reduceMotion ? 0 : speed,
      autoplay: wantsAutoplay
        ? {
            delay: parseInt(root.dataset.sliderDelay, 10) || 8000,
            /* Nu se opreste definitiv dupa ce vizitatorul apasa un punct: ar
               parea stricat daca ramane blocat pe un slide. */
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }
        : false,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: root.querySelector('.hero-banner__arrow--prev'),
        nextEl: root.querySelector('.hero-banner__arrow--next'),
      },
      a11y: {
        prevSlideMessage: 'Slide anterior',
        nextSlideMessage: 'Slide urmator',
      },
    });

    instances[id] = swiper;

    if (wantsAutoplay && swiper.autoplay) {
      pauseWhenOffscreen(root, swiper);
      pauseWhileFocusInside(root, swiper);
    }
  }

  /* Cat timp bannerul nu e pe ecran, schimbarile n-au spectator. Daca l-ar tot
     roti, vizitatorul care se intoarce sus ar prinde alt slide decat cel lasat
     si ar parea ca pagina s-a schimbat singura. */
  function pauseWhenOffscreen(root, swiper) {
    if (!('IntersectionObserver' in window)) return;

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            swiper.autoplay.start();
          } else {
            swiper.autoplay.stop();
          }
        });
      },
      { threshold: 0.35 }
    ).observe(root);
  }

  /* Cine navigheaza cu tastatura si ajunge pe butoanele din slide trebuie sa
     apuce sa le foloseasca; `pauseOnMouseEnter` nu acopera cazul asta. */
  function pauseWhileFocusInside(root, swiper) {
    root.addEventListener('focusin', function () {
      swiper.autoplay.stop();
    });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) swiper.autoplay.start();
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector(SELECTOR);
    if (root) destroy(root.dataset.sectionId);
  });
})();
